export default {
  heading: {
    widgetName: "food",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Discover Certified Super Food outlets",
    subHeadline: "Super value, great taste and bestsellers",
    showMoreURL: "https://www.airasia.com/food/my/en",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Discover Certified Super Food outlets`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper | Discover Certified Super Food outlets`,
    },
  },

  data: [
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/bltc3e6f152816565e9/6317160a688ff8311575d4d6/Sushi_Edo.png",
      title: "Sushi Edo",
      subtitle: "Bayan Lepas, Penang, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/sushi-edo"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt31c93e82438bfcc2/631716092bb66a2aab0a8540/Black_Whale_Malaysia.png",
      title: "The Black Whale - Karpal Singh",
      subtitle: "Georgetown, Penang, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/the-black-whale-karpal-singh"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt0a567fd13b07b7eb/63171608077f5f5de0ceca38/Nandos.png",
      title: "NANDO'S (Avenue K)",
      subtitle: "Kuala Lumpur, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/nandos-avenue-k"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/bltb67eb362a87a81cd/631716086d41f755ad534495/Subway.png",
      title: "Subway (Berjaya Times Square)",
      subtitle: "Kuala Lumpur, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/subway-berjaya-times-square"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blte4d42a9669d67d53/63171aa710bada5f14a3359f/TNR_By_SeanAngie.png",
      title: "TNR By Sean & Angie",
      subtitle: "Selangor, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/tnr-by-sean-angie"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/bltea10f0d7f0be809a/63171608c1142d2fd9dfd4f2/Face_To_Face_Noodle_House_Damansara_Perdana.png",
      title: "Face To Face Noodle House - Damansara Perdana",
      subtitle: "Selangor, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/face-to-face-noodle-house-damansara-perdana"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt1225ccc1afc30133/63171608454b1c2ebb3f32bb/Joshijosh_USJ_6_Subang.png",
      title: "Joshijosh (USJ 6, Subang)",
      subtitle: "Selangor, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/joshijosh-usj-6-subang"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt661bbfeccb1c9378/631716083f24842ec19c7e1d/TGI_Fridays.png",
      title: "TGI Fridays (Queensbay Mall)",
      subtitle: "Bayan Lepas, Penang, Malaysia",
      cta: "Order Now",
      url: "https://www.airasia.com/food/my/restaurant/tgi-fridays-queensbay-mall"
    }
  ]
}
